module.exports = __webpack_public_path__ + "static/media/skate.2f84ee98.svg";